
  <div class="content-single-insights">
    <div class="box-insights">
      <div class="wrapper-box-top">
        <div class="wrapper-icon purple">
          <img src="../../../../assets/icons/insights/icon-insights-followers.svg" alt="">
        </div>
        <span class="label1">{{insightsDetails?.[cardEntity] | number}}</span>
        <span class="label2">{{cardTitle}}</span>
      </div>
    </div>
    <span class="title-insights">{{'INSIGHTS.growth' | translate}}</span>
    <div *ngIf="insightsDetails?.growth" class="box-insights">
      <tl-area-chart
        [data]="insightsDetails.growth"
      ></tl-area-chart>
    </div>
    <div *ngIf="!insightsDetails?.growth" class="no-data-box">
      <span>No data</span>
    </div>
    <span class="title-insights">
      {{'INSIGHTS.top_locations' | translate}}
      </span>
    <div class="box-insights">
      <div class="box-insights-tabs">
        <div (click)="topLocationsActiveTab = InsightsTopLocationsTabsEnums.city" class="box-insights-tab" [ngClass]="{'active': topLocationsActiveTab === InsightsTopLocationsTabsEnums.city}">
          <span>{{'INSIGHTS.cities' | translate}}</span>
        </div>
        <div (click)="topLocationsActiveTab = InsightsTopLocationsTabsEnums.country" class="box-insights-tab" [ngClass]="{'active': topLocationsActiveTab === InsightsTopLocationsTabsEnums.country}">
          <span>{{'INSIGHTS.countries' | translate}}</span>
        </div>
      </div>
      <div *ngFor="let location of insightsDetails?.top_locations[topLocationsActiveTab] | keyvalue" class="wrapper-progressbar">
        <div class="header-progressbar">
          <span class="name">{{location.key ? location.key : 'Other'}}</span>
          <span class="percentage">{{location.value}}%</span>
        </div>
        <div class="content-progressbar">
          <div class="overlay-progressbar" [ngStyle]="{'width': location.value + '%'}"></div>
        </div>
      </div>
    </div>
    <span class="title-insights">{{'INSIGHTS.age_range' | translate}}</span>
    <div class="box-insights">
      <div class="box-insights-tabs">
        <div (click)="ageRangeActiveTab = InsightsAgeRangeTabsEnums.all" class="box-insights-tab" [ngClass]="{'active': ageRangeActiveTab === InsightsAgeRangeTabsEnums.all}">
          <span>{{'INSIGHTS.all' | translate}}</span>
        </div>
        <div (click)="ageRangeActiveTab = InsightsAgeRangeTabsEnums.man" class="box-insights-tab" [ngClass]="{'active': ageRangeActiveTab === InsightsAgeRangeTabsEnums.man}">
          <span>{{'INSIGHTS.men' | translate}}</span>
        </div>
        <div (click)="ageRangeActiveTab = InsightsAgeRangeTabsEnums.women" class="box-insights-tab" [ngClass]="{'active': ageRangeActiveTab === InsightsAgeRangeTabsEnums.women}">
          <span>{{'INSIGHTS.women' | translate}}</span>
        </div>
        <div (click)="ageRangeActiveTab = InsightsAgeRangeTabsEnums.other" class="box-insights-tab" [ngClass]="{'active': ageRangeActiveTab === InsightsAgeRangeTabsEnums.other}">
          <span>{{'CREATE_ACCOUNT.other' | translate}}</span>
        </div>
      </div>
      <div *ngFor="let ageRange of insightsDetails?.age_range[ageRangeActiveTab] | keyvalue" class="wrapper-progressbar">
        <div class="header-progressbar">
          <span class="name">{{ageRange.key !== 'not_available' ? ageRange.key : 'Not available'}}</span>
          <span class="percentage">{{ageRange.value}}%</span>
        </div>
        <div class="content-progressbar">
          <div class="overlay-progressbar" [ngStyle]="{'width': ageRange.value + '%'}"></div>
        </div>
      </div>
    </div>
    <span class="title-insights">{{'INSIGHTS.gender' | translate}}</span>
    <div *ngIf="insightsDetails?.gender.men || insightsDetails?.gender.women || insightsDetails?.gender.other" class="box-insights gender-box">
      <div class="wrapper-top-gender-chart">
        <div class="wrapper-legend-gender-chart">
          <div class="item-gender-chart">
            <div class="color-gender man"></div>
            <span>Men ({{insightsDetails?.gender.men}}%)</span>
          </div>
        </div>
        <div class="wrapper-chart-gender">
          <tl-donut-chart
            [data]="insightsDetails?.gender"
          ></tl-donut-chart>
        </div>
        <div class="wrapper-legend-gender-chart">
          <div class="item-gender-chart">
            <div class="color-gender woman"></div>
            <span>Women ({{insightsDetails?.gender.women}}%)</span>
          </div>
        </div>
      </div>
      <div class="wrapper-legend-gender-chart">
        <div class="item-gender-chart">
          <div class="color-gender other"></div>
          <span>Other ({{insightsDetails?.gender.other}}%)</span>
        </div>
      </div>
    </div>
    <div *ngIf="!insightsDetails?.gender.men && !insightsDetails?.gender.women" class="no-data-box">
      <span> {{'NEW_TEXT.no_data' | translate}}</span>
    </div>
    <span class="title-insights">{{'INSIGHTS.themes' | translate}}</span>
    <div class="box-insights themes">
      <div *ngFor="let theme of insightsDetails?.themes | keyvalue" class="wrapper-progressbar">
        <div class="header-progressbar">
          <span class="name">{{theme.key}}</span>
          <span class="percentage">{{theme.value}}%</span>
        </div>
        <div class="content-progressbar">
          <div class="overlay-progressbar" [ngStyle]="{'width': theme.value + '%'}"></div>
        </div>
      </div>
    </div>
  </div>
